import { LogoutMessage, LogoutResponseMessage, MessageHandler } from "../types";
import { core } from "@/index";
import { clearTokens } from "@/utils/tokenManager";

export interface LogoutHandlerConfig {
  onSuccess?: () => void;
  onError?: (error: string) => void;
  sendResponse: (message: LogoutResponseMessage) => void;
  redirectToEmbed?: boolean;
}

export const createLogoutHandler = (config: LogoutHandlerConfig): MessageHandler<LogoutMessage> => {
  return async () => {
    console.log("[LogoutHandler] Processing LOGOUT message");

    try {
      await clearTokens();
      await core.clear();

      config.sendResponse({
        type: "LOGOUT_RESPONSE",
        success: true,
        message: "Logout successful",
      });

      console.log("[LogoutHandler] Logout complete");

      if (config.onSuccess) {
        config.onSuccess();
      }

      if (config.redirectToEmbed !== false) {
        console.log("[LogoutHandler] Redirecting to embed screen...");
        window.location.hash = "#/embed";
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : "Unknown error";
      console.error("[LogoutHandler] Logout error:", error);

      config.sendResponse({
        type: "LOGOUT_RESPONSE",
        success: false,
        message: errorMessage,
      });

      if (config.onError) {
        config.onError(errorMessage);
      }
    }
  };
};
